import { getData } from 'src/api/http.service';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
import { getAPIEndpoints, handleApiError } from 'src/utils';
import { PaymentProvidersEnum } from 'src/models';

const financesActionTypes = {
  GET_ALL_PAYMENTS: 'GET_ALL_PAYMENTS',
};

const getAllPayments = ({
  page = 0,
  size = 10,
  sort = 'orderDateTime',
  startDate,
  endDate,
  paymentProvider,
} = {}) => async dispatch => {
  dispatch(ApiCallInProgress());
  let url = `${
    getAPIEndpoints().payments
  }?page=${page}&size=${size}&sort=${sort}&paymentProvider=${paymentProvider ||
    PaymentProvidersEnum.All}`;
  if (startDate) {
    url += `&startDate=${startDate}`;
  }
  if (endDate) {
    url += `&endDate=${endDate}`;
  }
  try {
    const response = await getData(url);
    dispatch({ type: financesActionTypes.GET_ALL_PAYMENTS, payload: response.data });
    dispatch(ApiCallSuccessAction({ message: '' }));
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};
const downloadInvoices = (url, data) => async dispatch => {
  dispatch(ApiCallInProgress());
  fetch(url, {
    method: 'POST',
    body: JSON.stringify({ invoiceUrls: data }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.blob())
    .then(blob => {
      dispatch(ApiCallSuccessAction({ message: '' }));
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'invoices.zip';
      document.body.appendChild(a);
      a.click();
      a.remove();
    })
    .catch(err => {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    });
};

export { getAllPayments, downloadInvoices, financesActionTypes };
